<form class="edit-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">

  <app-autocomplete *ngIf="!withOneClient" [control]="getControl('client')" [list]="clients"
    label="contacts.edit.client.label" errorMsg="contacts.edit.client.errorMessage">
  </app-autocomplete>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.firstname.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="firstname">
    <mat-error>{{ 'contacts.edit.firstname.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.lastname.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="lastname">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.email.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="email">
    <mat-error>{{ 'contacts.edit.email.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.gsm.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="gsm">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.phone.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="phone">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.fax.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="fax">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.locality.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="locality">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.postalCode.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="postalCode">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.street.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="street">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.streetNumber.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="streetNumber">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.service.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="service">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'contacts.edit.site.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="site">
  </mat-form-field>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>